import React, {memo} from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {Line, LineChart, ResponsiveContainer, XAxis, YAxis} from 'recharts';
import {reverse} from 'lodash';

const moment = require('moment');

const COLORS = ['#3f51b5', '#00C49F', '#FFBB28', '#FF8042'];

const Chart = props => {
    const {data, text, title} = props;

    const d = reverse(data).map(i => ({...i, name: moment(i.k * 1000).format('HH:mm')}));

    return <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <Paper style={{display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px', padding: '15px', maxWidth: '800px'}}>
            <Typography style={{marginBottom: '15px', fontWeight: '600'}} component='p'>{text(title)}</Typography>

            <div style={{width: '740px', height: '250px'}}>
                <ResponsiveContainer>
                    <LineChart data={d}>
                        <XAxis dataKey='name' padding={{left: 10, right: 10}}/>
                        <YAxis/>
                        <Line type='monotone' strokeWidth={4} dot={false} dataKey="v" stroke={COLORS[0]}/>
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </Paper>
    </div>;
};
export default memo(Chart);
